/* ══════════════════════════════════════════════════════════════
   ASSET MANIFEST
   Drop real files into /app/frontend/public/assets/ and point at
   them here. Anything left null falls back to the Axos product
   shots, so the page never breaks while assets are missing.

   Every path is served from the site root, so a file at
   /app/frontend/public/assets/ads/ad-01.jpg is "/assets/ads/ad-01.jpg".
   ══════════════════════════════════════════════════════════════ */

import { PROOF } from "./machines";

/* eight statics for the Meta machine, in order. null = use the product shot */
export const ADS = [
  "/assets/ads/ad-01.jpg",
  "/assets/ads/ad-02.jpg",
  "/assets/ads/ad-03.jpg",
  "/assets/ads/ad-04.jpg",
  "/assets/ads/ad-05.jpg",
  "/assets/ads/ad-06.jpg",
  "/assets/ads/ad-07.jpg",
  "/assets/ads/ad-08.jpg",
];

/* four produced statics for the Creative machine */
export const CREATIVE_ADS = [null, null, null, null];

/* one screenshot each. null = the machine keeps its drawn wireframe or panel */
export const LANDING_PAGE = null; // e.g. "/assets/pages/pdp-variant.jpg"
export const QUIZ = null; // e.g. "/assets/quiz/quiz-step-2.jpg"
export const EMAIL = null; // e.g. "/assets/email/welcome-stage-2.jpg"
export const MONDAY_REPORT = null; // e.g. "/assets/report/monday-one-pager.jpg"

/* resolve a frame image: an explicit asset, then the manifest, then the product shot */
export function frameSrc(imgKey, index, pool = ADS) {
  const fromPool = Array.isArray(pool) ? pool[index] : null;
  if (fromPool) return fromPool;
  if (imgKey && PROOF[imgKey]) return PROOF[imgKey];
  return PROOF.system;
}

/* used by <img onError> so a missing file degrades instead of showing a broken icon */
export function fallbackTo(e, imgKey) {
  const fb = (imgKey && PROOF[imgKey]) || PROOF.system;
  if (e?.currentTarget && e.currentTarget.src !== fb) e.currentTarget.src = fb;
}
